var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "flex-grow-1"
        }, 'div', attrs, false), on), [_vm.localValue && _vm.label ? _c('div', {
          staticClass: "d-flex mt-2 mb-n1"
        }, [_c('small', {
          staticClass: "v-label v-label--active theme--light ml-2"
        }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('v-spacer'), !_vm.disabled ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": "",
            "x-small": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t("edit")) + " ")]) : _vm._e()], 1) : _vm._e(), !_vm.localValue ? _c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": '',
            "readonly": "",
            "outlined": "",
            "label": !_vm.localValue ? _vm.label : '',
            "hint": _vm.hint,
            "persistent-hint": !!_vm.hint,
            "required": _vm.required,
            "rules": _vm.rules,
            "dense": _vm.dense
          }
        }, 'v-text-field', attrs, false), on)) : _c('refs-selected', _vm._g(_vm._b({
          key: 'refs-selected-' + _vm.localValue + _vm.refType,
          staticClass: "mb-8",
          attrs: {
            "value": [{
              refId: _vm.localValue,
              refType: _vm.refType
            }],
            "partnerId": _vm.partnerId,
            "removable": _vm.clearable,
            "confirmable": false,
            "outlined": true,
            "draggable": false
          },
          on: {
            "removed": function removed($event) {
              _vm.localValue = '';
            }
          }
        }, 'refs-selected', attrs, false), on))], 1)];
      }
    }]),
    model: {
      value: _vm.isMenu,
      callback: function callback($$v) {
        _vm.isMenu = $$v;
      },
      expression: "isMenu"
    }
  }, [_c('v-card', {
    staticClass: "pa-1"
  }, [_c('refs-selection-by-type', {
    attrs: {
      "refType": _vm.refType,
      "partnerId": _vm.partnerId,
      "showAsMenu": false,
      "filters": _vm.filters
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }